import { slugifySegment } from './prettyRoutes';

export interface PersonalAccountRoute {
  workspaceSlug: string;
  userSlug: string;
  section: string | null;
}

interface PersonalAccountPathInput {
  workspaceName: string;
  userName: string;
  section?: string | null;
}

/** A personal account is still viewed inside an active workspace. Keep both
 * readable identities in the address without leaking database identifiers. */
export function buildPersonalAccountPath({
  workspaceName,
  userName,
  section,
}: PersonalAccountPathInput): string {
  const base = `/account/${slugifySegment(workspaceName)}/${slugifySegment(userName)}`;
  return section && section !== 'overview'
    // Per segment, so a nested section such as preferences/general reads as a path rather than preferences%2Fgeneral.
    ? `${base}/${section.split('/').map(encodeURIComponent).join('/')}`
    : base;
}

export function parsePersonalAccountPath(pathname: string): PersonalAccountRoute | null {
  const match = pathname.match(/^\/account\/([^/]+)\/([^/]+)(?:\/([^/]+(?:\/[^/]+)?))?\/?$/);
  if (!match) return null;

  return {
    workspaceSlug: decodeURIComponent(match[1]),
    userSlug: decodeURIComponent(match[2]),
    section: match[3] ? match[3].split('/').map(decodeURIComponent).join('/') : null,
  };
}
